import { render, staticRenderFns } from "./SectionFertilizerSeller.vue?vue&type=template&id=d4c2fed6&scoped=true&"
import script from "./SectionFertilizerSeller.vue?vue&type=script&lang=js&"
export * from "./SectionFertilizerSeller.vue?vue&type=script&lang=js&"
import style0 from "./SectionFertilizerSeller.vue?vue&type=style&index=0&id=d4c2fed6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c2fed6",
  null
  
)

export default component.exports